import React from "react";
import { Col, Container, Row, Form, Label, Input, FormGroup } from "reactstrap";

const Card = (props) => {
  return (
    <React.Fragment>
      <Col lg={3} md={6}>
        <div className="contact-info text-center mt-5">
          <div className="icon">
            <i className={props.iconClass}></i>
          </div>
          <div className="mt-4 pt-2">
            <h6 className="fs-17">{props.title}</h6>
            {props.isChildItem.map((item, key) => (
              <p className="text-muted mb-0" key={key}>
                {item}
              </p>
            ))}
          </div>
        </div>
      </Col>
    </React.Fragment>
  );
};

// Contact Data - Araucária Solar

const ContactData = [
  {
    title: "Localização",
    iconClass: "mdi mdi-map-marker text-primary h4",
    isChildItem: ["Atendemos toda a região", "Consulte nossa área de cobertura"],
  },
  {
    title: "Telefone",
    iconClass: "mdi mdi-phone text-primary h4",
    isChildItem: ["(43) 98809-3460"],
  },
  {
    title: "E-mail",
    iconClass: "mdi mdi-email text-primary h4",
    isChildItem: ["contato@araucariasolar.com.br", "www.araucariasolar.com.br"],
  },
  {
    title: "Horário",
    iconClass: "mdi mdi-calendar-clock text-primary h4",
    isChildItem: ["Segunda a Sexta: 08:00 - 18:00", "Sábado: 08:00 - 12:00"],
  },
];

const Contact = () => {
  return (
    <React.Fragment>
      <section className="section bg-light" id="contato">
        <Container>
          <Row className="justify-content-center">
            <Col lg={7}>
              <div className="text-center mb-4">
                <p className="text-uppercase text-muted mb-2">Contato</p>
                <h3>Solicite seu Orçamento Gratuito</h3>
                <div className="title-border mt-3"></div>
                <p className="title-desc text-muted mt-3">
                  Entre em contato conosco e descubra quanto você pode economizar
                  com energia solar. Nossa equipe está pronta para atender você
                  e apresentar a melhor solução para sua necessidade.
                </p>
              </div>
            </Col>
          </Row>

          <Row className="justify-content-center">
            {ContactData.map((value, idx) => (
              <Card
                key={idx}
                title={value.title}
                iconClass={value.iconClass}
                isChildItem={value.isChildItem}
              />
            ))}
          </Row>

          <Row className="mt-5 pt-2 justify-content-center">
            <Col lg={9}>
              <div className="custom-form bg-white p-4 p-lg-5 rounded box-shadow">
                <h5 className="mb-4 text-center">Preencha o formulário abaixo</h5>
                <Form action="#" name="myForm">
                  <p id="error-msg"></p>
                  <Row>
                    <Col lg={6}>
                      <FormGroup>
                        <div className="mb-3">
                          <Label for="name" className="form-label">
                            Nome completo*
                          </Label>
                          <Input
                            name="name"
                            id="name"
                            type="text"
                            className="form-control"
                            placeholder="Seu nome"
                          />
                        </div>
                      </FormGroup>
                    </Col>
                    <Col lg={6}>
                      <FormGroup>
                        <div className="mb-3">
                          <Label for="email" className="form-label">
                            E-mail*
                          </Label>
                          <Input
                            type="email"
                            className="form-control"
                            name="email"
                            id="email"
                            placeholder="seu@email.com"
                          />
                        </div>
                      </FormGroup>
                    </Col>
                  </Row>

                  <Row>
                    <Col lg={6}>
                      <FormGroup>
                        <div className="mb-3">
                          <Label for="phone" className="form-label">
                            Telefone*
                          </Label>
                          <Input
                            type="tel"
                            className="form-control"
                            name="phone"
                            id="phone"
                            placeholder="(XX) XXXXX-XXXX"
                          />
                        </div>
                      </FormGroup>
                    </Col>

                    <Col lg={6}>
                      <FormGroup>
                        <div className="mb-3">
                          <Label for="bill" className="form-label">
                            Valor médio da conta de luz*
                          </Label>
                          <Input
                            type="select"
                            className="form-control"
                            name="bill"
                            id="bill"
                          >
                            <option value="">Selecione...</option>
                            <option value="ate-300">Até R$ 300</option>
                            <option value="300-500">R$ 300 a R$ 500</option>
                            <option value="500-1000">R$ 500 a R$ 1.000</option>
                            <option value="1000-2000">R$ 1.000 a R$ 2.000</option>
                            <option value="acima-2000">Acima de R$ 2.000</option>
                          </Input>
                        </div>
                      </FormGroup>
                    </Col>

                    <Col lg={12}>
                      <FormGroup>
                        <div className="mb-3">
                          <Label for="type" className="form-label">
                            Tipo de instalação*
                          </Label>
                          <Input
                            type="select"
                            className="form-control"
                            name="type"
                            id="type"
                          >
                            <option value="">Selecione...</option>
                            <option value="residencial">Residencial</option>
                            <option value="comercial">Comercial</option>
                            <option value="industrial">Industrial</option>
                            <option value="rural">Rural/Agronegócio</option>
                          </Input>
                        </div>
                      </FormGroup>
                    </Col>

                    <Col lg={12}>
                      <FormGroup>
                        <div className="mb-3">
                          <Label for="message" className="form-label">
                            Mensagem (opcional)
                          </Label>
                          <Input
                            type="textarea"
                            className="form-control"
                            placeholder="Conte-nos mais sobre sua necessidade..."
                            name="message"
                            id="message"
                            style={{ height: "100px" }}
                          />
                        </div>
                      </FormGroup>
                    </Col>
                  </Row>

                  <Row>
                    <Col lg={12}>
                      <FormGroup>
                        <div className="mt-3 text-center">
                          <input
                            type="submit"
                            id="submit"
                            name="send"
                            className="submitBnt btn btn-primary btn-lg px-5"
                            value="Solicitar Orçamento Grátis"
                          />
                          <div id="simple-msg"></div>
                        </div>
                      </FormGroup>
                    </Col>
                  </Row>
                </Form>
              </div>
            </Col>
          </Row>
        </Container>
      </section>
    </React.Fragment>
  );
};

export default Contact;
